module.exports = __webpack_public_path__ + "img/thumbnail_DallSheep_m_normal.602b9bfe.png";